import { Page, Text, View, Document, Image } from '@react-pdf/renderer';

// Constants
import { CV_TEMPLATE_ID, IMAGES } from '@shared/constants';
import { ExportFormat } from '@/constants/resume';

// Utils
import { isEmptyValueArray } from '@shared/utils';
import { removeGoogleImageSizeParam } from '@/utils';
import { buildFileName } from '@/utils/resume';

// Types
import { TemplateProps } from '../../type';

// Styles
import styles from './style';

// Components
import PersonalInfoSection from './components/Sidebar/PersonalInfo';
import EducationSection from './components/Sidebar/Education';
import SkillsSection from './components/Sidebar/TechnicalSkills';
import CertificationsSection from './components/Sidebar/Certificates';
import BioSection from './components/Content/Bio';
import ExperienceSection from './components/Content/Experiences';
const Default = ({
  data
}: TemplateProps) => {
  const {
    info,
    technicalSkills,
    journeys,
    educations,
    certs
  } = data || {};
  const technicalSkillsData = (technicalSkills ?? []).filter(skill => {
    const {
      name = '',
      items = []
    } = skill;
    return name.trim() !== '' || items.some(item => item.trim() !== '');
  });
  const {
    name = '',
    bio = '',
    previewImageBase64 = IMAGES.AVATAR_DEFAULT_PNG,
    avatar = '',
    avatarResume = ''
  } = info || {};
  const hasPersonalInfo = info?.name || info?.title || info?.email || info?.phone || info?.address || info?.birthday || previewImageBase64 !== IMAGES.AVATAR_DEFAULT_PNG || info?.links && !isEmptyValueArray(info.links);
  const fileName = buildFileName(ExportFormat.PDF, name);
  const currentAvatar = avatarResume || removeGoogleImageSizeParam(avatar) || previewImageBase64;
  const renderHeader = () => <View style={styles.header} fixed data-sentry-element="View" data-sentry-component="renderHeader" data-sentry-source-file="index.tsx">
      <Image style={styles.logo} src={'/images/agility-logo.png'} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </View>;
  const renderFooter = () => <View style={styles.footer} fixed data-sentry-element="View" data-sentry-component="renderFooter" data-sentry-source-file="index.tsx">
      <View style={styles.pageNumberWrapper} data-sentry-element="View" data-sentry-source-file="index.tsx">
        <Text style={styles.pageNumberText} render={({
        pageNumber
      }) => `${pageNumber}`} data-sentry-element="Text" data-sentry-source-file="index.tsx" />
      </View>
    </View>;
  return <Document title={fileName} data-sentry-element="Document" data-sentry-component="Default" data-sentry-source-file="index.tsx">
      <Page size="A4" style={styles.page} data-sentry-element="Page" data-sentry-source-file="index.tsx">
        {renderHeader()}

        <View style={styles.container} data-sentry-element="View" data-sentry-source-file="index.tsx">
          <View style={styles.sidebar} data-sentry-element="View" data-sentry-source-file="index.tsx">
            <PersonalInfoSection info={info} currentAvatar={currentAvatar} hasPersonalInfo={!!hasPersonalInfo} data-sentry-element="PersonalInfoSection" data-sentry-source-file="index.tsx" />
            <EducationSection educations={educations} data-sentry-element="EducationSection" data-sentry-source-file="index.tsx" />
            <SkillsSection technicalSkills={technicalSkills} technicalSkillsData={technicalSkillsData} data-sentry-element="SkillsSection" data-sentry-source-file="index.tsx" />
            <CertificationsSection certs={certs} data-sentry-element="CertificationsSection" data-sentry-source-file="index.tsx" />
          </View>

          <View style={styles.content} wrap data-sentry-element="View" data-sentry-source-file="index.tsx">
            <BioSection bio={bio} data-sentry-element="BioSection" data-sentry-source-file="index.tsx" />
            <ExperienceSection journeys={journeys} data-sentry-element="ExperienceSection" data-sentry-source-file="index.tsx" />
          </View>
        </View>

        {renderFooter()}
        <View style={styles.borderLastPage} data-sentry-element="View" data-sentry-source-file="index.tsx" />
      </Page>
    </Document>;
};
export const DEFAULT_TEMPLATE_INFO = {
  id: CV_TEMPLATE_ID.DEFAULT,
  title: 'Default',
  description: 'A modern and elegant resume template designed to make a lasting impression.',
  thumbnail: IMAGES.CV_TEMPLATE,
  component: Default
};
export default Default;